import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  return <Router data-id="element-0" data-mp="3k7i5r8vye84a">
      <Routes data-id="element-1" data-mp="3k78dtfrclqvy">
        <Route path="/" element={<HomePage data-id="element-3" data-mp="3fa850x346a15" />} data-id="element-2" data-mp="3farf5rmivu4m" />
        <Route path="/services" element={<ServicesPage data-id="element-5" data-mp="3f8nfjlvnpha5" />} data-id="element-4" data-mp="3fb17hlv1iddh" />
        <Route path="/about" element={<AboutPage data-id="element-7" data-mp="2rlp1svyx8nfx" />} data-id="element-6" data-mp="2rkdxmv1kddoa" />
      </Routes>
    </Router>;
}